<div *ngIf="authenticatepage && pageContent">
  <div class="main-wrapper">
    <section class="signup-section startdate-tab">
      <div *ngIf="errorMessage" class="alert valign-children-middle error-container">
        <div class="alert-error" role="img">
          <i class="icon-badgealert" aria-label="alert"></i>
        </div>
        <div>{{errorMessage}}</div>
      </div>
      <div *ngIf='initModal'>
        <app-modal [showModal]="initModal" [modalClass]="modalClass">
          <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit'
            (modalOutput)="closeModal()">
          </app-confirm-modal>
        </app-modal>
      </div>
      <h2>{{pageContent.heading}}</h2>


      <div *ngIf="!mixedCombination">
        <div *ngFor="let page of pageDescription">
          <div *ngIf="!page.hide">
            <!-- <h3 *ngIf="page.header1">{{page.header1}}</h3> -->
            <!-- <div *ngIf='oemStatus'> -->
              <span [innerHTML]="page.description"></span>
              <!--<span *ngIf="!page.gridOptions">
            <a href="javascript:void(0)" (click)='learn()'> {{pageContent.learnMore}} </a>
          </span> -->
            <!-- </div> -->
            <!-- <div *ngIf='!oemStatus'>{{page.descriptionOem}}</div> -->
            <ng-container *ngTemplateOutlet="accordionOrCustomGridTemplate; context: { page: page }"></ng-container>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="confirmModalTemplate"></ng-container>
        <div class="select-dates" *ngFor="let field of formInputs">
          <ng-container
            *ngTemplateOutlet=" field.id !== 'existing' ? datePickerTemplate : checkboxTemplate; context: { field: field }">
          </ng-container>
        </div>
      </div>


      <!-- Start of mixedCombination case -->
      <div *ngIf="mixedCombination" class="mixedCombination">
        <!-- <h3>All accounts with unenrolled devices</h3>
        <p>To enroll existing devices on all accounts, select an enrollment date.</p> -->
        <!-- <app-customgrid [gridOptions]="pageDescription[2].gridOptions" (onDataChange)="pageDescription[2].gridCallback($event)">
      </app-customgrid> -->
        <span [innerHTML]="pageContent.description"></span>
        <ng-container *ngTemplateOutlet="confirmModalTemplate"></ng-container>
        <div class="select-dates" *ngFor=" let field of formInputs; let i = index">
          <ng-container
            *ngTemplateOutlet=" field.id !== 'existing' ? datePickerTemplate : checkboxTemplate; context: { field: field }">
          </ng-container>
          <ng-container *ngTemplateOutlet="accordionOrCustomGridTemplate; context: { page: pageDescription[i] }"></ng-container>
        </div>
      </div>
      <!-- End of mixedCombination case -->


      <!-- <div class="ios-message"> -->
      <div class="ios-message" *ngIf='!oemStatus'>
        {{pageContent.IOSDeviceInfo}}
      </div>


      <div class="cta">
        <button [disabled]="errorMessage" class="btn btn-secondary" (click)="next()"
          [attr.aria-label]="pageContent.buttons.continue"> {{pageContent.buttons.continue}} </button>
        <a href="#" class="btn btn-link back-button-enrollDate" (click)="back($event)"
          [attr.aria-label]="pageContent.buttons.back"> {{pageContent.buttons.back}} </a>
      </div>
      <div class="accordion-section supportArticles" *ngIf="!oemStatus?supportArticle:supportArticle">
        <app-accordion [accordion]="supportArticles" [accordionController]=false>
          <app-accordion-list *ngFor="let optio of supportArticles; let i=index " [option]='optio'
            [isSubAccordion]=true>
            <div class="support-content">
              <a href="javascript:void(0)" title="Opens a new dialog."
                (click)="getSupportContent(0)">{{article.name}}</a>
            </div>
          </app-accordion-list>
        </app-accordion>
      </div>
      <div *ngIf='showSupportModal'>
        <app-modal [showModal]="showSupportModal">
          <app-confirm-modal [modalPopupObject]='learnMoreModal' [triggerElement]='eventEmit'
            (modalOutput)="closeModal($event)">
          </app-confirm-modal>
        </app-modal>
      </div>
    </section>
  </div>
</div>


<!-- Templates -->

<ng-template #datePickerTemplate let-field="field">
  <div class="device-header">
    <h3 [class]="field.dateInput.labelColor">{{field.title}}
      <ng-container *ngTemplateOutlet="tooltipButtonTemplate; context: { field: field }"></ng-container>
    </h3>
  </div>
  <div class="enter-date">
    <app-date-picker datePickerHeading="{{field.title}}" [datePickerInput]="field.dateInput"
      (updateDate)="onDateChange($event)" [showError]="field.id === 'new' ? false : false">
    </app-date-picker>
  </div>
</ng-template>

<ng-template #checkboxTemplate let-field="field">
  <div class="device-header">
    <label aria-label="checkbox" class="checkbox">
      <input type="checkbox" [(ngModel)]="enrollmentCheckbox.checked" [disabled]="enrollmentCheckbox.disabled" />
      <i class="skin"></i>
      <h3 attr.class="{{ field.dateInput.labelColor }} checkboxHeader">{{field.title}}</h3>
    </label>
    <ng-container *ngTemplateOutlet="tooltipButtonTemplate; context: { field: field }"></ng-container>
  </div>
</ng-template>

<ng-template #tooltipButtonTemplate let-field="field">
  <button class="tooltip-container">
    <i class="icon-flat-faq tooltip-icon" tabindex="0" [attr.aria-describedby]="field.title"
      [attr.aria-label]="field.toolTipText.text"></i>
    <div role="tooltip" class="helper-text" [id]="field.toolTipText.heading">
      <h5 *ngIf="field.toolTipText.heading">{{field.toolTipText.heading}}</h5>
      <p>{{field.toolTipText.text}}</p>
    </div>
  </button>
</ng-template>

<ng-template #confirmModalTemplate>
  <div class="row enrollDateInfo">
    <div class="alert-icon">
      <i aria-label="Alert" class="icon-alert .ico" role="img"></i>
    </div>
    <div class="extra-content">
      <span [innerHTML]="pageContent.enrollDatePopup.pageText"></span>
      <a href="javascript:void(0);" title="Opens a new dialog."
        (click)="showenroll()">{{pageContent.enrollDatePopup.pageLinkText}}</a>
    </div>
  </div>
  <div *ngIf='showEnrollDetailsModal'>
    <app-modal [showModal]="showEnrollDetailsModal">
      <app-confirm-modal [modalPopupObject]='enrollDatePopup' [triggerElement]='eventEmit'
        (modalOutput)="closePopupModal($event)">
      </app-confirm-modal>
    </app-modal>
  </div>
</ng-template>

<ng-template #accordionOrCustomGridTemplate let-page="page">
  <div class="list-container" *ngIf="page.gridOptions">
    <div *ngIf="page.accordion" class="accordion-grid">
      <div *ngIf="page.moreThanFiveFan">
        <app-accordion *ngIf="page.accordion" [accordion]="page.accordion" [accordionController]=false>
          <app-accordion-list *ngFor="let FAN of page.accordion" [option]="FAN" [isSubAccordion]=true>
            <app-customgrid [gridOptions]="page.gridOptions" (onDataChange)="page.gridCallback($event)">
            </app-customgrid>
          </app-accordion-list>
        </app-accordion>
      </div>
      <div *ngIf="!page.moreThanFiveFan">
        <app-customgrid [gridOptions]="page.gridOptions" (onDataChange)="page.gridCallback($event)">
        </app-customgrid>
      </div>
    </div>
    <div *ngIf="!page.accordion">
      <h4>{{page.gridHeader}}</h4>
      <app-customgrid [gridOptions]="page.gridOptions" (onDataChange)="page.gridCallback($event)">
      </app-customgrid>
    </div>
  </div>
</ng-template>